'use strict';

/* global $ */
/* global _ */
/* global Marionette */

class BasketBlock extends Marionette.View {
    modelEvents() {
        return {
            'change:count': 'render'
        };
    }
    getTemplate() {
        if (this.model.get('count') > 0){
            return '#tpl-order__basket__full';
        } else {
            return '#tpl-order__basket__empty';
        }
    }
}

export { BasketBlock };
